
import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserModule } from '../../store/modules/user';
import { IPagination } from '@/types';
import {
  faultList,
  deleteFault,
  deleteFaultAll,
  addFault,
  editFault,
  exportFaultType
} from '@/api/fault';
import { makeKey } from '@/utils/qiniu';
import { limit } from '@/types/limit';
import { getQiniuToken } from '@/api/third';
import { Qiniu } from '@/types/qiniu';
import DialogSetImport from '../staff/components/setImport.vue';
import DialogImgLarge from '@/components/ImgLarge/index.vue';

@Component({
  name: 'SettingTemplateFault',
  components: {
    DialogSetImport,
    DialogImgLarge
  }
})
export default class extends Vue {
  private formSearch = {
    fault: ''
  };
  private faultOptions = [];
  private upperOptions = [
    {
      id: '1',
      name: '顶级分类'
    }
  ];

  private tableData = [];
  private dialogAddFaultVisible = false;
  private formFault: any = {
    fault_id: 0,
    upper: '',
    fault: '',
    radioIsfamiliar: '0',
    img: '',
    fullImg: '',
    ranking: 100
  };
  private action: string = 'https://up-z1.qiniup.com';
  private qiniu: any = {};
  private form: object = {};
  private dialogAddFaultSubVisible = false;
  private formAddFaultSub = {
    fault_id: '0',
    pid: '',
    fault: '',
    radioIsfamiliar: '0',
    level: '',
    ranking: '100'
  };
  private dialogEditFaultSubVisible = false;
  private formEditFaultSub: any = {
    fault_id: '0',
    upper: '',
    fault: '',
    radioIsfamiliar: '0',
    level: '',
    ranking: '100'
  };

  private listLoading = false;

  // 页码处理
  private pagination: IPagination = {
    currentPage: 1,
    pageSize: 10,
    total: 0
  };

  private rules = {
    fault: [
      {
        required: true,
        message: '请填写2-20位字符',
        trigger: 'blur'
      },
      {
        min: 2,
        max: 20,
        message: '请填写2-20位字符',
        trigger: 'blur'
      }
      // {
      //   pattern: /[\u4e00-\u9fa5a-zA-Z0-9]/,
      //   message: '请填写2-20位由字母、中文组成的姓名',
      //   trigger: 'blur'
      // }
    ]
  };

  created() {
    this.pagination.currentPage = 1;
    this.getList('');
    const params = {
      type: Qiniu.UPLOAD_TYPE_FAULT
    };
    getQiniuToken(params).then((res) => {
      if (res && res.data) {
        this.qiniu = res.data;
      }
    });
  }

  // fault_id
  // fault_name
  // 列表获取
  private getList(faultName: any) {
    this.listLoading = true;
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      page: this.pagination.currentPage,
      size: this.pagination.pageSize,
      fault_name: faultName
    };
    faultList(params)
      .then((res) => {
        const data = res.data;
        if (data) {
          this.tableData = data.list;
          if (!faultName) {
            this.faultOptions = data.list;
          }
          this.pagination.total = parseInt(data.count);
          this.pagination.pageSize = parseInt(data.page_size);
          this.pagination.currentPage = parseInt(data.page_current);
        } else {
          this.pagination.currentPage = 1;
          this.pagination.total = 0;
          this.tableData = [];
          if (!faultName) {
            this.faultOptions = data.list;
          }
        }
        this.listLoading = false;
      })
      .catch((err) => {
        this.pagination.total = 0;
        this.tableData = [];
        this.listLoading = false;
        let msg = err.msg;
      });
  }

  // 搜索
  private handleSearch() {
    this.pagination.currentPage = 1;
    this.getList(this.formSearch.fault);
  }

  // 清除
  private handleClear() {
    this.formSearch = {
      fault: ''
    };
    this.handleSearch();
  }

  // 页码切换
  handleCurrentChange(size: number) {
    this.pagination.currentPage = size;
    this.getList(this.formSearch.fault);
  }

  // 页码切换
  handlePageSizeChange(size: number) {
    this.pagination.pageSize = size;
    this.getList(this.formSearch.fault);
  }

  // 添加故障类型 初始化数据
  private handelAddFault() {
    this.dialogAddFaultVisible = true;
    this.upperOptions = [
      {
        id: '0',
        name: '顶级分类'
      }
    ];
    this.upperOptions = this.upperOptions.concat(this.faultOptions);
    this.formFault = {
      fault_id: 0,
      upper: this.upperOptions[0],
      fault: '',
      radioIsfamiliar: '0',
      img: '',
      fullImg: '',
      ranking: 100
    };
  }

  // 添加故障类型 验证必填项
  private saveFault() {
    (this.$refs.ruleForm as any).validate((valid: any) => {
      if (valid) {
        this.saveFaultNet();
        this.dialogAddFaultVisible = false;
      } else {
        return false;
      }
    });
  }

  // 保存 故障类型
  private saveFaultNet() {
    const params : any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      pid: this.formFault.upper.id,
      name: this.formFault.fault,
      is_common: this.formFault.radioIsfamiliar,
      image_save_path: this.formFault.img,
      sort: this.formFault.ranking
    };
    if (parseInt(this.formFault.fault_id) === 0) {
      this.addFault(params);
    } else {
      params.fault_id = this.formFault.fault_id;
      this.editFault(params);
    }
  }

  // 编辑故障类型
  private editHandle(val:any) {
    this.dialogAddFaultVisible = true;
    this.upperOptions = [
      {
        id: '0',
        name: '顶级分类'
      }
    ];
    this.upperOptions = this.upperOptions.concat(this.faultOptions);
    this.formFault = {
      fault_id: val.id,
      upper: this.upperOptions[0],
      fault: val.name,
      radioIsfamiliar: val.is_common,
      img: val.image_save_path,
      fullImg: val.image_real_path,
      ranking: val.sort
    };
  }
  // 编辑子类故障类型
  private editSubHandle(val:any,parent:any) {
    this.dialogEditFaultSubVisible = true;  
    //如果编辑三级
    if(parent){
      //找到this.faultOptions里pid等于val的id人child
      let itemCurrent:any = this.faultOptions.find((item:any) => {
        return parseInt(item.id) === parseInt(parent.pid);
      });
      this.upperOptions = itemCurrent.child;
    }else{
      this.upperOptions = [
        {
          id: '0',
          name: '顶级分类'
        }
      ];
      this.upperOptions = this.upperOptions.concat(this.faultOptions);
    }
    var opp:any = '';
    for (var i = 0; i < this.upperOptions.length; i++) {
      if (this.upperOptions[i].id === val.pid) {
        opp = this.upperOptions[i];
        break;
      }
    }
    this.formEditFaultSub = {
      fault_id: val.id,
      upper: opp,
      fault: val.name,
      radioIsfamiliar: val.is_common,
      level: val.level,
      ranking: val.sort
    };
  }
  // 保存 编辑子类故障类型
  private handelEditFaultSub() {
    if (!this.formEditFaultSub.fault) {
      this.showErrorMsg('请输入故障类型');
      return;
    }
    const params : any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      pid: this.formEditFaultSub.upper.id,
      name: this.formEditFaultSub.fault,
      is_common: this.formEditFaultSub.radioIsfamiliar,
      level: this.formEditFaultSub.level,
      sort: this.formEditFaultSub.ranking
    };
    if (parseInt(this.formEditFaultSub.fault_id) === 0) {
      this.addFault(params);
    } else {
      params.fault_id = this.formEditFaultSub.fault_id;
      this.editFault(params);
    }
  }
  // 添加子类故障类型
  private addSubHandle(val:any) {
    this.dialogAddFaultSubVisible = true;
    this.formAddFaultSub = {
      fault_id: '0',
      pid: val.id,
      fault: '',
      radioIsfamiliar: '0',
      level: '',
      ranking: '100'
    };
  }
  // 添加子类故障类型 保存
  private handelAddFaultSub() {
    if (!this.formAddFaultSub.fault) {
      this.showErrorMsg('请输入故障类型');
      return;
    }
    const params : any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      pid: this.formAddFaultSub.pid,
      name: this.formAddFaultSub.fault,
      is_common: this.formAddFaultSub.radioIsfamiliar,
      level: this.formAddFaultSub.level,
      sort: this.formAddFaultSub.ranking
    };
    if (parseInt(this.formAddFaultSub.fault_id) === 0) {
      this.addFault(params);
    } else {
      params.fault_id = this.formAddFaultSub.fault_id;
      this.editFault(params);
    }
  }
  // 删除
  private deleteDataHandle(val:any) {
    this.$confirm('确定删除这条数据?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        const params = {
          user_id: UserModule.getUserId,
          company_id: UserModule.getCompanyId,
          fault_id: val.id
        };
        deleteFault(params)
          .then((res:any) => {
            this.showSuccessMsg(res.msg);
            this.handleClear();
          })
          .catch((err) => {
            this.showErrorMsg(err.msg);
          });
      })
      .catch(() => {
      });
  }
  // 添加联网
  private addFault(params :any) {
    addFault(params)
      .then((res:any) => {
        this.dialogAddFaultVisible = false;
        this.dialogAddFaultSubVisible = false;
        this.showSuccessMsg(res.msg);
        this.handleClear();
      })
      .catch((err) => {
        let msg = err.msg;
        this.showErrorMsg(msg);
      });
  }
  // 编辑联网
  private editFault(params :any) {
    editFault(params)
      .then((res:any) => {
        this.dialogEditFaultSubVisible = false;
        this.showSuccessMsg(res.msg);
        this.handleClear();
      })
      .catch((err) => {
        let msg = err.msg;
        this.showErrorMsg(msg);
      });
  }
  // 导入故障类型
  private setImportVisible = false
  private setImportTitle='导入故障类型'

  private importFault() {
    this.setImportVisible = true;
  }

  closeImport(value: boolean) {
    this.pagination.currentPage = 1;
    this.getList('');
    this.setImportVisible = value;
  }

  // 上传图片成功
  private handleFaultImage(val: any) {
    this.formFault.img = val.key;
    this.formFault.fullImg = (this.form as any).default_url + val.key;
  }

  // 上传图片准备
  private beforeUpload(file: any) {
    const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
    const isLt2M =
      file.size / 1024 / 1024 < limit.ORDER_SERVICE_ADD_IMAGE_MAX_SIZE;
    if (!isJPG) {
      return this.$message.error('上传文件只能是  JPG或PNG 格式!');
    }
    if (!isLt2M) {
      return this.$message.error(
        '上传图片大小不能超过 ' + limit.ORDER_SERVICE_ADD_IMAGE_MAX_SIZE + 'MB!'
      );
    }
    return new Promise((resolve, reject) => {
      resolve(true);
    }).then((res) => {
      let k = makeKey(this.qiniu.prekey);
      this.form = {
        key: k,
        token: this.qiniu.uptoken,
        domain: this.qiniu.domain,
      };
    });
  }


  handleExport() {
    let params = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: UserModule.getCompanyId,
      company_name: UserModule.getCompanyName,
      type : 1,
    };
    exportFaultType(params).then(res => {
      this.$confirm('是否跳转下载页面？', '跳转', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let routeData = this.$router.resolve({
          path: '/ExportTask',
          query: {}
        });
        window.open(routeData.href);
      }).catch(() => {

      });
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }

  // 批量删除
  private multipleDeleteItem: any = []
  private multipleDeleteInner: any = []
  private delGroupHandle() {
    if (!this.multipleDeleteItem || this.multipleDeleteItem.length < 1) {
      this.showErrorMsg('请选择故障现象');
      return;
    }
    let ids = '';
    for (const iterator of this.multipleDeleteItem) {
      ids = ids + iterator.id + ',';
    }
    let pamars:any = {};
    pamars.user_id = UserModule.getUserId;
    pamars.company_id = UserModule.getCompanyId;
    pamars.fault_ids = ids.substring(0, ids.length - 1);
    pamars.type = 1;
    deleteFaultAll(pamars).then((res:any) => {
      this.showSuccessMsg(res.msg);
      this.pagination.currentPage = 1;
      this.getList(this.formSearch.fault);
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  private selectAllChange(selection: any) {
    this.multipleDeleteItem = selection;
    if (selection.length > 0) {
      selection.forEach((row: any) => {
        if (row.child && row.child.length > 0) {
          this.toggleSelectionInnerChange(row.child, true);
        }
      });
    } else {
      this.toggleSelectionInnerChange([], false);
    }
  }
  private selectedChange(selection: any, row: any) {
    this.multipleDeleteItem = selection;
    let arr = selection.filter((t: any) => {
      return row.id === t.id;
    });

    if (arr && arr.length > 0) {
      if (this.$refs.multipleDeleteInner) {
        this.toggleSelectionInnerChange(row.child, true);
      }
    } else {
      if (this.$refs.multipleDeleteInner) {
        this.toggleSelectionInnerChange(row.child, false);
      }
    }
  }
  private selectedInnerChange(selection: any, row: any) {
    this.multipleDeleteInner = selection;
    this.multipleDeleteItem = this.multipleDeleteItem.concat(this.multipleDeleteInner);
  }
  private toggleSelectionInnerChange(rows: any, select:boolean) {
    if (rows.length > 0) {
      rows.forEach((row: any) => {
        if (this.$refs.multipleDeleteInner) {
          (this.$refs.multipleDeleteInner as any).toggleRowSelection(row, select);
        }
      });
    } else {
      if (this.$refs.multipleDeleteInner) {
        (this.$refs.multipleDeleteInner as any).clearSelection();
      }
    }
  }

  private imgLargeHandle(val: [], index: number) {
    let enlargedData = {
      isShow: true,
      imgList: [val],
      initNum: index
    };
    this.$store.dispatch('toggleEnlarged', enlargedData);
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }

  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: window.innerHeight * 0.4,
      customClass: 'notification-center',
      type: 'success'
    });
  }
}
